import http from 'http/http';
import { api } from 'http/helpers';
import URLS from 'http/urls';

import { ConfigParam } from './types';

export const configManagementApi = {
  fetchConfig() {
    return http.get<ConfigParam[]>(api(URLS.config));
  },
  createConfigItem(paramKey: string, paramValue: string) {
    return http.post<unknown, ConfigParam>(api(URLS.config), {
      paramKey,
      paramValue,
    });
  },
  updateConfigItem(id: string, paramValue: string) {
    return http.put<unknown, ConfigParam>(
      api(URLS.configItem),
      { paramValue },
      {
        replacePathParams: { id },
      },
    );
  },
  invalidateCache() {
    return http.put(api(URLS.configCache), {});
  },
};
